// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function checkboxCssStyle(themeObj) {
  return ".container {\n  display: flex;\n  cursor: pointer;\n  position: relative;\n}\n\n.container input {\n  position: absolute;\n  transform: scale(0);\n}\n\n.container input:checked ~ .checkmark {\n  transform: rotate(45deg);\n  height: 1em;\n  width: .4em;\n  border-color: " + themeObj.colorTextSecondary + ";\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-radius: 0;\n  margin-top: -2px;\n  margin-left: 8px;\n}\n\n.container .checkmark {\n  display: block;\n  width: 1em;\n  height: 1em;\n  border: 2px solid " + themeObj.colorTextSecondary + ";\n  border-radius: 2px;\n  transition: all .3s;\n}\n";
}

function Checkbox(props) {
  var __ariaLabelUnchecked = props.ariaLabelUnchecked;
  var __ariaLabelChecked = props.ariaLabelChecked;
  var label = props.label;
  var onChange = props.onChange;
  var isChecked = props.isChecked;
  var ariaLabelChecked = __ariaLabelChecked !== undefined ? __ariaLabelChecked : "";
  var ariaLabelUnchecked = __ariaLabelUnchecked !== undefined ? __ariaLabelUnchecked : "";
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var css = checkboxCssStyle(match.themeObj);
  var handleChange = function (ev) {
    var target = ev.target;
    var value = target.checked;
    onChange(value);
  };
  var match$1 = isChecked ? [
      "Checkbox--checked",
      "CheckboxInput--checked",
      "CheckboxLabel--checked"
    ] : [
      "",
      "",
      ""
    ];
  var checkedState = match$1[1];
  var ariaLabel = ariaLabelChecked.length > 0 && ariaLabelUnchecked.length > 0 ? (
      isChecked ? ariaLabelChecked : ariaLabelUnchecked
    ) : "";
  return React.createElement("div", {
              "aria-label": ariaLabel.length > 0 ? ariaLabel : label,
              "aria-checked": isChecked ? "true" : "false",
              className: "Checkbox " + match$1[0] + " flex flex-row gap-2 items-center",
              role: "checkbox",
              tabIndex: 0,
              onKeyDown: (function ($$event) {
                  var key = $$event.key;
                  var keyCode = $$event.keyCode;
                  if (key === "Enter" || keyCode === 13) {
                    return onChange(!isChecked);
                  }
                  
                })
            }, React.createElement("style", undefined, css), React.createElement("label", {
                  className: "container CheckboxInput " + checkedState
                }, React.createElement("input", {
                      tabIndex: -1,
                      checked: isChecked,
                      type: "checkbox",
                      onChange: handleChange
                    }), React.createElement("div", {
                      className: "checkmark CheckboxInput " + checkedState
                    }), React.createElement("div", {
                      className: "CheckboxLabel " + match$1[2] + " ml-2 opacity-50 text-xs select-none"
                    }, label)));
}

var make = Checkbox;

export {
  checkboxCssStyle ,
  make ,
}
/* react Not a pure module */
